import { render } from "./incident-stats.vue?vue&type=template&id=29a52d0f&scoped=true"
import script from "./incident-stats.vue?vue&type=script&lang=js"
export * from "./incident-stats.vue?vue&type=script&lang=js"

import "./incident-stats.vue?vue&type=style&index=0&id=29a52d0f&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a52d0f"]])

export default __exports__